export default __webpack_public_path__ + "static/media/calendar-icon-red.dbbc6d72.svg";